import { useState } from "react";
import { LuReceipt } from "react-icons/lu";
import { FiPlay } from "react-icons/fi";

import ListPageShell from "../list-page/ListPageShell";
import ListPageHeader from "../list-page/ListPageHeader";
import ReceiptDrawStage from "./ReceiptDrawStage";
import { LAB_TIERS, LAB_TOTAL_RECEIPTS, buildLabBusinessWinners, buildLabWinners } from "./labData";

const COUNTS = [1, 3, 5, 10];

const Segmented = ({ options, value, onChange, render }) => (
  <div className="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-1 gap-1">
    {options.map((o) => (
      <button
        key={render(o)}
        type="button"
        onClick={() => onChange(o)}
        className={`px-3 py-1.5 rounded-md text-sm font-semibold transition ${
          o === value ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-800"
        }`}
      >
        {render(o)}
      </button>
    ))}
  </div>
);

/* Sandbox for a receipt-pile draw animation. Uses dummy data only — nothing is
   generated or stored. Reachable at /draw-lab. */
export default function ReceiptDrawLab() {
  const [count, setCount] = useState(5);
  const [tier, setTier] = useState(LAB_TIERS[0]);
  const [run, setRun] = useState(null); // { key, winners, businessWinners }

  const start = () => {
    const winners = buildLabWinners(count, tier);
    setRun({ key: Date.now(), winners, businessWinners: buildLabBusinessWinners(winners) });
  };

  return (
    <ListPageShell>
      <ListPageHeader
        eyebrow={{ icon: <LuReceipt size={18} />, label: "Laborator" }}
        title="Tërheqja nga kuponat"
        subtitle="Animacion eksperimental: një kupon tërhiqet nga një grumbull i madh kuponash."
      />

      <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-5 sm:p-6">
        <div className="flex flex-col gap-5 max-w-xl mx-auto">
          <div className="flex items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm text-amber-800">
            <span className="rounded-md bg-amber-400 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">Demo</span>
            Të dhëna testuese — asnjë fitues nuk gjenerohet ose ruhet.
          </div>

          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">Numri i fituesve</span>
            <Segmented options={COUNTS} value={count} onChange={setCount} render={(c) => c} />
          </div>

          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">Kushti</span>
            <Segmented
              options={LAB_TIERS}
              value={tier}
              onChange={setTier}
              render={(t) => `Kushti ${t.tier_level} · ${t.prize_amount}€`}
            />
          </div>

          <button
            type="button"
            onClick={start}
            className="inline-flex items-center justify-center gap-3 rounded-xl bg-[var(--secondary-color)] hover:bg-[var(--secondary-color)]/90 active:scale-[0.99] px-4 py-3.5 text-base font-bold text-white shadow-sm transition"
          >
            <FiPlay size={18} />
            Fillo tërheqjen
          </button>
        </div>
      </div>

      {run && (
        <ReceiptDrawStage
          key={run.key}
          winners={run.winners}
          businessWinners={run.businessWinners}
          totalReceipts={LAB_TOTAL_RECEIPTS}
          subtitle={`Lotaria e Vjeshtës · Kushti ${tier.tier_level}`}
          onClose={() => setRun(null)}
          onReplay={start}
          demo
        />
      )}
    </ListPageShell>
  );
}
